/**
 * Enhanced scroll functionality for InterPals messages
 * Addresses issues with scrolling to bottom in message threads
 * Eliminates flash by pre-positioning container and handling dynamic content
 */

/**
 * Initialize scroll functionality on page load
 * Handles direct navigation to PM threads
 */
function initializeScrollOnPageLoad() {
  // Check if we're on the PM page with messages already loaded
  const threadsRight = $("#threads_right");
  const threadsMain = $("#threads_main");
  
  if (threadsRight.length > 0 && threadsMain.hasClass("threads--open")) {
    // We have a thread open on page load (direct navigation)
    
    // Setup scroll observer for dynamic content
    setupScrollObserver(threadsRight);
    
    // Wait for all content to load, including images, then scroll
    setTimeout(() => {
      scrollToBottomAfterImagesLoad(threadsRight, 3000);
    }, 100);
  }
}

// Initialize when DOM is ready
$(document).ready(function() {
  if ($('.privateMessages').length > 0) {
    initializeScrollOnPageLoad();
    
    // Add resize listener to handle orientation changes on mobile
    let resizeTimeout;
    $(window).on('resize orientationchange', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const threadsRight = $("#threads_right");
        if (threadsRight.length > 0 && threadsRight.find('.msg').length > 0) {
          scrollToBottomEnhanced(threadsRight, 100, false);
        }
      }, 250);
    });
  }
});

/**
 * Enhanced scroll to bottom function
 */
function scrollToBottomEnhanced(element, delay = 200, immediate = false) {
  if (!element || element.length === 0) {
    return;
  }

  const executeScroll = () => {
    const $element = $(element);
    const domElement = $element.get(0);
    
    if (!domElement) {
      return;
    }

    const scrollHeight = domElement.scrollHeight;
    const clientHeight = domElement.clientHeight;

    // Calculate the correct scroll position accounting for container padding and mobile input
    const computedStyle = window.getComputedStyle(domElement);
    const paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    
    // Check for mobile bottom navigation and message input overlapping
    let fixedInputHeight = 0;
    
    // Check for mobile bottom navigation first (only on mobile screens)
    const isMobile = window.innerWidth <= 640;
    if (isMobile) {
      // On mobile, check if bottom navigation exists and add its height
      const mobileBottomNav = $('[data-component="mobile-bottom-nav"]');
      if (mobileBottomNav.length > 0 && mobileBottomNav.is(':visible')) {
        fixedInputHeight += mobileBottomNav.outerHeight() || 90; // fallback to 90px
      } else {
        // Fallback: assume standard mobile bottom nav height if element not found but we're on mobile
        fixedInputHeight += 90;
      }
    }
    
    // Then check for message input
    const inputBottom = $("#threads_right_bottom");
    if (inputBottom.length > 0) {
      const inputStyle = window.getComputedStyle(inputBottom.get(0));
      const isInputFixed = inputStyle.position === 'fixed';
      
      if (isInputFixed) {
        // Add input height to the total fixed height
        fixedInputHeight += inputBottom.outerHeight() || 0;
      }
    }
    
    // The actual content height is scrollHeight minus the padding
    const contentHeight = scrollHeight - paddingBottom;
    // On mobile, we also need to account for the fixed input height
    const availableHeight = clientHeight - fixedInputHeight;
    const maxScrollTop = Math.max(0, contentHeight - availableHeight);
    // Try multiple scroll methods for maximum compatibility
    try {
      if (immediate) {
        // For initial loads, scroll immediately without animation to prevent flash
        domElement.scrollTop = maxScrollTop;
      } else {
        // For new messages, use smooth scrolling
        domElement.scrollTo({
          top: maxScrollTop,
          left: 0,
          behavior: 'smooth'
        });
      }
    } catch {
      try {
        // Fallback: Direct scrollTop assignment
        domElement.scrollTop = maxScrollTop;
      } catch (fallbackError) {
      }
    }

    // Verify scroll worked (only for non-immediate scrolls)
    if (!immediate) {
      setTimeout(() => {
        const newScrollTop = domElement.scrollTop;
        const verifyComputedStyle = window.getComputedStyle(domElement);
        const verifyPaddingBottom = parseInt(verifyComputedStyle.paddingBottom, 10) || 0;
        
        // Check for mobile bottom navigation and input overlap
        let verifyFixedInputHeight = 0;
        
        // Check for mobile bottom navigation first
        const verifyIsMobile = window.innerWidth <= 640;
        if (verifyIsMobile) {
          // On mobile, check if bottom navigation exists and add its height
          const verifyMobileBottomNav = $('[data-component="mobile-bottom-nav"]');
          if (verifyMobileBottomNav.length > 0 && verifyMobileBottomNav.is(':visible')) {
            verifyFixedInputHeight += verifyMobileBottomNav.outerHeight() || 90; // fallback to 90px
          } else {
            // Fallback: assume standard mobile bottom nav height if element not found but we're on mobile
            verifyFixedInputHeight += 90;
          }
        }
        
        // Then check for message input
        const verifyInputBottom = $("#threads_right_bottom");
        if (verifyInputBottom.length > 0) {
          const verifyInputStyle = window.getComputedStyle(verifyInputBottom.get(0));
          const verifyIsInputFixed = verifyInputStyle.position === 'fixed';
          
          if (verifyIsInputFixed) {
            verifyFixedInputHeight += verifyInputBottom.outerHeight() || 0;
          }
        }
        
        const verifyContentHeight = domElement.scrollHeight - verifyPaddingBottom;
        const verifyAvailableHeight = domElement.clientHeight - verifyFixedInputHeight;
        const verifyMaxScrollTop = Math.max(0, verifyContentHeight - verifyAvailableHeight);
        const isAtBottom = Math.abs(newScrollTop - verifyMaxScrollTop) <= 5; // 5px tolerance
        
        if (!isAtBottom && scrollHeight > clientHeight) {
          domElement.scrollTop = verifyMaxScrollTop;
        }
      }, 300);
    }
  };

  if (immediate || delay === 0) {
    executeScroll();
  } else {
    setTimeout(executeScroll, delay);
  }
}

/**
 * Pre-position container to bottom before content loads
 */
function prePositionToBottom(element) {
  const domElement = $(element).get(0);
  if (domElement) {
    // Use scrollHeight for more precise positioning instead of arbitrary large number
    domElement.scrollTop = domElement.scrollHeight;
  }
}

/**
 * Wait for images to load and then scroll to bottom
 */
function scrollToBottomAfterImagesLoad(element, maxWait = 3000) {
  const $element = $(element);
  const images = $element.find('img');
  
  if (images.length === 0) {
    // No images, scroll immediately
    scrollToBottomEnhanced(element, 0, true);
    return;
  }
  
  let loadedImages = 0;
  const startTime = Date.now();
  
  const checkComplete = () => {
    if (loadedImages >= images.length || (Date.now() - startTime) > maxWait) {
      scrollToBottomEnhanced(element, 0, true);
    }
  };
  
  images.each(function() {
    const img = this;
    if (img.complete) {
      loadedImages++;
    } else {
      $(img).on('load error', () => {
        loadedImages++;
        checkComplete();
      });
    }
  });
  
  // Initial check in case all images are already loaded
  checkComplete();
  
  // Fallback timeout
  setTimeout(() => {
    if (loadedImages < images.length) {
      scrollToBottomEnhanced(element, 0, true);
    }
  }, maxWait);
}

/**
 * Setup mutation observer to handle dynamic content changes
 */
function setupScrollObserver(element) {
  const $element = $(element);
  const domElement = $element.get(0);
  
  if (!domElement || domElement._scrollObserver) {
    return; // Already set up
  }
  
  const observer = new MutationObserver((mutations) => {
    let shouldScroll = false;
    
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // New content added
        shouldScroll = true;
      }
    });
    
    if (shouldScroll) {
      // Check if we were already at the bottom before the content change
      const scrollHeight = domElement.scrollHeight;
      const scrollTop = domElement.scrollTop;
      const clientHeight = domElement.clientHeight;
      const wasAtBottom = Math.abs(scrollTop - (scrollHeight - clientHeight)) <= 10;
      
      if (wasAtBottom) {
        // We were at bottom, so scroll to new bottom after a brief delay
        setTimeout(() => scrollToBottomEnhanced(element, 0, true), 100);
      }
    }
  });
  
  observer.observe(domElement, {
    childList: true,
    subtree: true,
    attributes: false
  });
  
  domElement._scrollObserver = observer;
}

/**
 * Override the original append_msgs function to use enhanced scrolling
 */
if (typeof window.append_msgs_original === 'undefined') {
  // Save the original function
  window.append_msgs_original = window.append_msgs;
  
  // Replace with enhanced version
  window.append_msgs = function(msg_data, target) {
    // Call original function logic
    const msgs_jq = jQuery(msg_data);

    // Collapse messages from same user
    const last_user = $("#threads_right").find(".msg_username:last").text();
    if (last_user === msgs_jq.find(".msg_username:first").text()) {
      msgs_jq.find(".msg_meta_wrapper:first").remove();
    }

    target.append(msgs_jq);
    
    // If conversation empty, remove no_messages indicator
    if (target.find(".no_messages").length) {
      target.find(".no_messages").remove();
    }
    
    // Use enhanced scrolling with smooth animation for new messages
    scrollToBottomEnhanced(target, 100, false);
  };
}

/**
 * Override the view_thread function to use enhanced scrolling
 */
if (typeof window.view_thread_original === 'undefined') {
  // Save original function
  window.view_thread_original = window.view_thread;
  
  // Create enhanced version that preserves thread list scroll
  window.view_thread = function(thread_id, reload_messages) {
    window.reload_ads();

    $("#alert_bar").remove();

    var msg = $("#message"),
      tl = $("#threads_left"),
      thread = $("#thread_" + thread_id),
      tm = $("#threads_main"),
      use_browser_cached_draft = typeof last_draft[thread_id] != "undefined",
      localDraft = window.draftStorage ? window.draftStorage.load(thread_id) : null;

    // Preserve thread list scroll position
    var tlEl = tl[0];
    var savedThreadScroll = tlEl ? tlEl.scrollTop : 0;

    if (reload_messages) {
      $("#threads_main").removeClass("send");
      msg.val("");
      $("#send_thread_id").val(thread_id);
      $("#markitup_msg").empty();
    }

    window.setTimeout(function() {
      window.remove_new_mark();
    }, 3000);

    if (reload_messages && (localDraft !== null || use_browser_cached_draft)) {
      var draft = localDraft !== null ? localDraft : last_draft[thread_id];
      msg.val(draft);
      if (draft) {
        $("#threads_main").addClass("send");
      }
      if (window.updateSendButtonState) window.updateSendButtonState();
    }

    tm.addClass("threads--open");
    $("#threads-right__container").removeClass("hidden").addClass("flex");
    $("#threads-right__container > div:first-child").removeClass("hidden");
    $("#threads_right_bottom").removeClass("hidden");
    $("#conversation-actions-menu").addClass("hidden");
    $(".thread-actions-menu").addClass("hidden");
    $(".thread-swipe-actions").removeClass("translate-x-0").addClass("translate-x-full");

    window.threads_main_resize();
    if (tlEl) tlEl.scrollTop = savedThreadScroll;
    window.update_user_header(thread_id);

    tl.find(".pm_thread").removeClass("active");
    thread.addClass("active");

    // Scroll page to top without affecting inner scroll containers
    window.scrollTo(0, 0);
    if (tlEl) tlEl.scrollTop = savedThreadScroll;

    window.update_change_view_link(thread_id);

    // Guard scroll position for 300ms to survive async reflows
    if (tlEl && savedThreadScroll > 0) {
      var guardCount = 0;
      var scrollGuard = setInterval(function() {
        tlEl.scrollTop = savedThreadScroll;
        if (++guardCount >= 30) clearInterval(scrollGuard);
      }, 10);
    }

    if (!reload_messages) return false;

    thread.find(".pm_new_circle").remove();
    thread.removeClass("new");

    var ctw = $("#close_thread_wrap");
    ctw.removeClass("visible");
    ctw.show();

    var c = $("#threads_right");

    // PRE-POSITION: Set container to bottom BEFORE loading content to prevent flash
    prePositionToBottom(c);

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/pm.php",
      data: {
        "action": "load_messages",
        "thread": thread_id,
        "load_draft": (localDraft !== null || use_browser_cached_draft) ? 0 : 1
      },
      dataType: "json"
    }).done(function(data) {
      c.empty();
      if (data.body) {
        c.append(data.body);
        if (typeof data.lobc != "undefined") {
          thread.data("lobc", data.lobc);
        }
        if (data.draft.length > 0) {
          msg.val(data.draft);
          $("#threads_main").addClass("send");
        }
        
        // Initialize audio players synchronously before scrolling
        // so their rendered height is accounted for
        if (window.initAudioPlayers) window.initAudioPlayers();

        // Setup scroll observer for dynamic content
        setupScrollObserver(c);

        // Wait for images to load, then scroll to bottom
        scrollToBottomAfterImagesLoad(c, 3000);
      } else {
        if (data.error) {
          c.append($('<div class="error"></div>').html(data.error));
        } else {
          c.append($('<div class="error"></div>').html("This conversation is currently empty."));
        }
        // Still scroll to bottom for error messages
        scrollToBottomEnhanced(c, 0, true);
      }
      window.focus_msg_box();
    }).fail(function() {
      c.empty();
      c.append($('<div class="error"></div>').html("Error loading messages"));
      scrollToBottomEnhanced(c, 0, true);
    }).always(function() {
      window.pm_ajax_request_active = 0;
    });
    
    return false;
  };
}

// Export enhanced scroll function globally
window.scrollToBottomEnhanced = scrollToBottomEnhanced;
window.prePositionToBottom = prePositionToBottom;
window.scrollToBottomAfterImagesLoad = scrollToBottomAfterImagesLoad;
window.setupScrollObserver = setupScrollObserver;
window.initializeScrollOnPageLoad = initializeScrollOnPageLoad; 